import React, { useMemo } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useCreateUrlMutation } from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {  IUrl } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";

interface IUrlpopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IUrl;
}

const Taxes = ({ openModel = false, handleCloseDialog, data }: IUrlpopup) => {
  const classes = useStyles();
  const [open] = React.useState(openModel);
  const [newCoursing, { isLoading }] = useCreateUrlMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const handleClose = () => {
    handleCloseDialog(false);
  };

  const formik = useFormik({
    initialValues: {
      id: data?.id,
      urlName: data?.urlName,
      urlLink: data?.urlLink,
     
    },

     validate: (values) => {
      const errors: { [key: string]: string } = {};

       if (!values.urlName) errors.urlName = "URL Name is required";

       return errors;
    },
    onSubmit: async (values) => {
      try {
        const temData = {
          id: values?.id,
          urlName: values.urlName,
          urlLink: values.urlLink,
       
        };
        if (!data) {
          delete values.id;
        }

        const addCompanyResponse = await newCoursing(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.urlName === "" ||
      formik.values.urlLink === "" 
      ? false
      : true;
  }, [formik]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Edit Url
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Url Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                       <Grid item lg={6} md={6} sm={12} xs={12}>
                                           <Grid container alignItems="center">
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <Typography variant="subtitle1">URL Name</Typography>
                                             </Grid>
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <TextField
                                                 placeholder="Enter URL Name"
                                                 size="small"
                                                 {...formik.getFieldProps("urlName")}
                                                 className={classes.textField}
                                                 InputProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                                                 InputLabelProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                            error={formik.touched.urlName && Boolean(formik.errors.urlName)}
                            helperText={formik.touched.urlName && formik.errors.urlName}
                                               />
                                             </Grid>
                                           </Grid>
                                         </Grid>
                     
                                         <Grid item lg={6} md={6} sm={12} xs={12}>
                                           <Grid container alignItems="center">
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <Typography variant="subtitle1">URL Link</Typography>
                                             </Grid>
                                             <Grid item lg={12} md={12} sm={12} xs={12}>
                                               <TextField
                                                 placeholder="Enter URL Link"
                                                 size="small"
                                                 {...formik.getFieldProps("urlLink")}
                                                 className={classes.textField}
                                                 InputProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                                                 InputLabelProps={{
                                                   sx: {
                                                     fontSize: 14,
                                                   },
                                                 }}
                                               />
                                             </Grid>
                                           </Grid>
                                         </Grid>

                     
                     
                  
                      
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                         // disabled={!formValid || isLoading}
                           disabled={isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Taxes;
